import { render, staticRenderFns } from "./CmgGiftCard.vue?vue&type=template&id=3714826b&scoped=true&lang=pug"
import script from "./cmg-gift-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-gift-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgGiftCard.vue?vue&type=style&index=0&id=3714826b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3714826b",
  null
  
)

export default component.exports